// extracted by mini-css-extract-plugin
module.exports = {"content":"NewUser_content__3LugS","dataContent":"NewUser_dataContent__3sZ7d","card":"NewUser_card__1R0Ko","sectionForm":"NewUser_sectionForm__30u4F"};